export default __webpack_public_path__ + "static/media/vendor_story_3.bfacc95f.svg";